export const ISRAEL_COMMUNITY = 1;
export const BRAZIL_COMMUNITY = 2;
export const DEUTSCH_COMMUNITY = 8;

export const SHARINGOOD_COMMUNITY = "sharingood";